export const es = {
  sidebar: {
    title: 'ReMatter AI',
    newChat: 'Nuevo Chat',
    searchPlaceholder: 'Buscar',
    recentChats: 'Chats Recientes',
    loading: 'Cargando...',
    noChats: 'No hay chats aun. Haz clic en "Nuevo Chat" para comenzar.',
    selectChat: 'Selecciona un chat o crea uno nuevo para comenzar',
  },
  header: {
    lastUpdated: 'Actualizado',
    shared: 'Compartido',
    share: 'Compartir',
    rename: 'Renombrar',
    delete: 'Eliminar',
    deleteDialog: {
      title: 'Eliminar chat',
      message:
        '¿Estás seguro de que deseas eliminar este chat? Esta acción no se puede deshacer.',
      cancel: 'Cancelar',
    },
    shareDialog: {
      title: 'Compartir Chat',
      description:
        'Cualquier persona en tu organización con este enlace puede ver esta conversación.',
      copyLink: 'Copiar Enlace',
      copied: '¡Copiado!',
      revoke: 'Revocar Acceso',
      revokeConfirm:
        '¿Estás seguro? Cualquier persona con este enlace perderá acceso.',
      cancel: 'Cancelar',
    },
  },
  input: {
    placeholder:
      'Escribe ej. crear OV, anular trabajo #, conciliar reserva #, ...',
    addAttachment: 'Adjuntar Archivo',
    sending: '...',
    submitKey: 'Enter',
  },
  chat: {
    thinking: 'Pensando',
    arguments: 'Argumentos',
    result: 'Resultado',
    loadedPreviousChat: 'Se cargo tu conversacion reciente',
    errorLabel: 'Error',
    errorCode: 'Código:',
    readOnlyMessage:
      'Esta es una conversación compartida. Puedes ver pero no enviar mensajes.',
    sharedLinkInvalid:
      'Este enlace de chat compartido es inválido o ha sido revocado.',
    toolError: 'Error de Herramienta',
    toolResult: 'Resultado de herramienta',
    toolResultSuffix: 'resultado',
    view: 'Ver',
    source: 'Fuente',
    data: 'Datos',
  },
  prompts: {
    title: 'Pregunta. Revisa. Crea.',
    subtitle: (
      <span>
        Con <b>Rae</b>, la asistente de IA, las operaciones se vuelven mas
        faciles
      </span>
    ),
    suggestions: {
      createJob: 'Crear un Trabajo para un conductor para manana',
      createSalesOrder: 'Crear una Orden de Venta que inicie hoy',
      showInventory:
        'Mostrar el inventario total disponible en todas las instalaciones',
    },
  },
  logs: {
    noDataAvailable: 'No hay datos disponibles',
    archivedChat: 'Chat archivado',
    chatDetails: 'Detalles del chat',
    chatCreated: 'Chat creado',
    chatUpdated: 'Chat actualizado',
    chatArchived: 'Chat archivado',
    chatTitleUpdated: 'Titulo del chat actualizado',
    unknownEvent: 'Evento desconocido',
    rawPayloadParseError: 'Payload sin procesar (Error de analisis)',
    chatStatus: {
      unspecified: 'No especificado',
      active: 'Activo',
      archived: 'Archivado',
    },
    chat: 'Chat',
    titleUpdate: 'Actualización de titulo',
    changes: 'Cambios',
    before: 'Antes',
    after: 'Después',
    messageDetails: 'Detalles del Mensaje',
    messageParts: 'Partes del Mensaje',
    chatMessageCreated: 'Mensaje de Chat Creado',
    fields: {
      id: 'ID',
      title: 'Titulo',
      status: 'Estado',
      agentId: 'ID de Agente',
      userId: 'ID de Usuario',
      chatId: 'ID de Chat',
      newTitle: 'Nuevo Titulo',
      role: 'Rol',
      partsCount: 'Cantidad de Partes',
      sequence: 'Secuencia',
      type: 'Tipo',
      content: 'Contenido',
      toolName: 'Nombre de Herramienta',
      unknown: 'Desconocido',
    },
    chatMessageRole: {
      unspecified: 'No especificado',
      user: 'Usuario',
      assistant: 'Asistente',
      system: 'Sistema',
    },
  },
  tools: {
    names: {
      'agent-delegate': 'Trabajando...',
      'agent-delegate result': 'Listo',
      'general-userInput': 'Preguntar al Usuario',
      'general-dateTime': 'Fecha/Hora Actual',
      'crm-account-get': 'Obtener Cuenta',
      'crm-account-list': 'Listar Cuentas',
      'crm-account-create': 'Crear Cuenta',
      'crm-contact-list': 'Listar Contactos',
      'inventory-item-get': 'Obtener Articulo',
      'inventory-item-list': 'Listar Articulos',
      'sales-salesOrder-list': 'Listar Ordenes de Venta',
      'sales-salesOrder-get': 'Obtener Orden de Venta',
      'crm-account-delete': 'Eliminar Cuenta',
      'crm-account-update': 'Actualizar Cuenta',
      'crm-accountAddress-create': 'Crear Direccion de Cuenta',
      'crm-accountAddress-delete': 'Eliminar Direccion de Cuenta',
      'crm-accountAddress-get': 'Obtener Direccion de Cuenta',
      'crm-accountAddress-list': 'Listar Direcciones de Cuenta',
      'crm-accountAddress-update': 'Actualizar Direccion de Cuenta',
      'crm-contact-create': 'Crear Contacto',
      'crm-contact-delete': 'Eliminar Contacto',
      'crm-contact-get': 'Obtener Contacto',
      'crm-contact-update': 'Actualizar Contacto',
      'crm-customerInvitation-accept': 'Aceptar Invitacion de Cliente',
      'crm-customerInvitation-cancel': 'Cancelar Invitacion de Cliente',
      'crm-customerInvitation-create': 'Crear Invitacion de Cliente',
      'crm-customerInvitation-get': 'Obtener Invitacion de Cliente',
      'crm-customerInvitation-getByToken':
        'Obtener Invitacion de Cliente por Token',
      'crm-customerInvitation-list': 'Listar Invitaciones de Cliente',
      'sales-booking-create': 'Crear Reserva',
      'sales-booking-get': 'Obtener Reserva',
      'sales-booking-list': 'Listar Reservas',
      'sales-booking-update': 'Actualizar Reserva',
      'sales-deductionType-create': 'Crear Tipo de Deduccion',
      'sales-deductionType-delete': 'Eliminar Tipo de Deduccion',
      'sales-deductionType-get': 'Obtener Tipo de Deduccion',
      'sales-deductionType-list': 'Listar Tipos de Deduccion',
      'sales-deductionType-update': 'Actualizar Tipo de Deduccion',
      'sales-load-create': 'Crear Carga',
      'sales-load-get': 'Obtener Carga',
      'sales-load-list': 'Listar Cargas',
      'sales-load-update': 'Actualizar Carga',
      'sales-loadReconciliation-delete': 'Eliminar Conciliacion de Carga',
      'sales-loadReconciliation-update': 'Actualizar Conciliacion de Carga',
      'sales-salesOrder-create': 'Crear Orden de Venta',
      'sales-salesOrder-update': 'Actualizar Orden de Venta',
      'inventory-category-create': 'Crear Categoria',
      'inventory-category-delete': 'Eliminar Categoria',
      'inventory-category-get': 'Obtener Categoria',
      'inventory-category-list': 'Listar Categorias',
      'inventory-category-update': 'Actualizar Categoria',
      'inventory-inventoryTag-create': 'Crear Etiqueta de Inventario',
      'inventory-inventoryTag-delete': 'Eliminar Etiqueta de Inventario',
      'inventory-inventoryTag-get': 'Obtener Etiqueta de Inventario',
      'inventory-inventoryTag-list': 'Listar Etiquetas de Inventario',
      'inventory-inventoryTag-update': 'Actualizar Etiqueta de Inventario',
      'inventory-item-create': 'Crear Articulo',
      'inventory-item-delete': 'Eliminar Articulo',
      'inventory-item-update': 'Actualizar Articulo',
      'inventory-itemGroup-create': 'Crear Grupo de Articulos',
      'inventory-itemGroup-delete': 'Eliminar Grupo de Articulos',
      'inventory-itemGroup-get': 'Obtener Grupo de Articulos',
      'inventory-itemGroup-list': 'Listar Grupos de Articulos',
      'inventory-itemGroup-update': 'Actualizar Grupo de Articulos',
      'core-customAttribute-create': 'Crear Atributo Personalizado',
      'core-customAttribute-delete': 'Eliminar Atributo Personalizado',
      'core-customAttribute-get': 'Obtener Atributo Personalizado',
      'core-customAttribute-list': 'Listar Atributos Personalizados',
      'core-customAttribute-update': 'Actualizar Atributo Personalizado',
      'core-customAttribute-validate': 'Validar Atributo Personalizado',
      'core-facility-create': 'Crear Instalacion',
      'core-facility-get': 'Obtener Instalacion',
      'core-facility-list': 'Listar Instalaciones',
      'core-facilityGroup-assignFacility':
        'Asignar Instalacion a Grupo de Instalaciones',
      'core-facilityGroup-create': 'Crear Grupo de Instalaciones',
      'core-facilityGroup-get': 'Obtener Grupo de Instalaciones',
      'core-facilityGroup-list': 'Listar Grupos de Instalaciones',
      'core-facilityGroup-removeFacility':
        'Remover Instalacion del Grupo de Instalaciones',
      'core-facilityGroup-update': 'Actualizar Grupo de Instalaciones',
      'core-organization-create': 'Crear Organizacion',
      'core-organization-delete': 'Eliminar Organizacion',
      'core-organization-get': 'Obtener Organizacion',
      'core-organization-list': 'Listar Organizaciones',
      'core-organization-update': 'Actualizar Organizacion',
      'core-scopedSettingValues-getBySetting':
        'Obtener Valores de Configuracion por Alcance',
      'core-scopedSettingValues-patch':
        'Actualizar Valores de Configuracion por Alcance',
      'core-setting-create': 'Crear Configuracion',
      'core-setting-delete': 'Eliminar Configuracion',
      'core-setting-get': 'Obtener Configuracion',
      'core-setting-list': 'Listar Configuraciones',
      'core-setting-update': 'Actualizar Configuracion',
      'core-settingsGroup-create': 'Crear Grupo de Configuraciones',
      'core-settingsGroup-delete': 'Eliminar Grupo de Configuraciones',
      'core-settingsGroup-get': 'Obtener Grupo de Configuraciones',
      'core-settingsGroup-list': 'Listar Grupos de Configuraciones',
      'core-settingsGroup-update': 'Actualizar Grupo de Configuraciones',
      'core-user-create': 'Crear Usuario',
      'core-user-get': 'Obtener Usuario',
      'core-user-list': 'Listar Usuarios',
      'files-file-generateAccessURL': 'Generar URL de Acceso al Archivo',
      'files-file-get': 'Obtener Archivo',
      'files-file-list': 'Listar Archivos',
      'files-fileTemplate-get': 'Obtener Plantilla de Archivo',
      'files-fileTemplate-list': 'Listar Plantillas de Archivo',
      'files-fileTemplate-set': 'Establecer Plantilla de Archivo',
      'files-fileTemplate-remove': 'Remover Plantilla de Archivo',
      'finance-bill-create': 'Crear Factura de Proveedor',
      'finance-bill-get': 'Obtener Factura de Proveedor',
      'finance-bill-list': 'Listar Facturas de Proveedor',
      'finance-financialAccount-create': 'Crear Cuenta Financiera',
      'finance-financialAccount-list': 'Listar Cuentas Financieras',
      'finance-invoice-create': 'Crear Factura',
      'finance-invoice-get': 'Obtener Factura',
      'finance-invoice-list': 'Listar Facturas',
      'finance-payment-create': 'Crear Pago',
      'finance-payment-list': 'Listar Pagos',
      'purchases-purchaseOrder-list': 'Listar Ordenes de Compra',
      'purchases-purchaseOrder-get': 'Obtener Orden de Compra',
      'purchases-purchaseOrder-create': 'Crear Orden de Compra',
      'purchases-purchaseOrder-update': 'Actualizar Orden de Compra',
      'transportation-asset-create': 'Crear Activo',
      'transportation-asset-delete': 'Eliminar Activo',
      'transportation-asset-get': 'Obtener Activo',
      'transportation-asset-list': 'Listar Activos',
      'transportation-asset-update': 'Actualizar Activo',
      'transportation-assetType-create': 'Crear Tipo de Activo',
      'transportation-assetType-delete': 'Eliminar Tipo de Activo',
      'transportation-assetType-get': 'Obtener Tipo de Activo',
      'transportation-assetType-list': 'Listar Tipos de Activo',
      'transportation-assetType-update': 'Actualizar Tipo de Activo',
      'transportation-containerType-create': 'Crear Tipo de Contenedor',
      'transportation-containerType-delete': 'Eliminar Tipo de Contenedor',
      'transportation-containerType-get': 'Obtener Tipo de Contenedor',
      'transportation-containerType-list': 'Listar Tipos de Contenedor',
      'transportation-containerType-update': 'Actualizar Tipo de Contenedor',
      'transportation-driver-create': 'Crear Conductor',
      'transportation-driver-get': 'Obtener Conductor',
      'transportation-driver-list': 'Listar Conductores',
      'transportation-driver-update': 'Actualizar Conductor',
      'transportation-freightForwarder-create': 'Crear Agente de Carga',
      'transportation-freightForwarder-delete': 'Eliminar Agente de Carga',
      'transportation-freightForwarder-get': 'Obtener Agente de Carga',
      'transportation-freightForwarder-list': 'Listar Agentes de Carga',
      'transportation-freightForwarder-update': 'Actualizar Agente de Carga',
      'transportation-freightLine-create': 'Crear Linea de Flete',
      'transportation-freightLine-delete': 'Eliminar Linea de Flete',
      'transportation-freightLine-get': 'Obtener Linea de Flete',
      'transportation-freightLine-list': 'Listar Lineas de Flete',
      'transportation-freightLine-update': 'Actualizar Linea de Flete',
      'transportation-hauler-add': 'Agregar Transportista',
      'transportation-hauler-remove': 'Remover Transportista',
      'transportation-route-create': 'Crear Ruta',
      'transportation-route-get': 'Obtener Ruta',
      'transportation-route-list': 'Listar Rutas',
      'transportation-route-update': 'Actualizar Ruta',
      'transportation-shippingCarrier-create': 'Crear Transportadora',
      'transportation-shippingCarrier-delete': 'Eliminar Transportadora',
      'transportation-shippingCarrier-get': 'Obtener Transportadora',
      'transportation-shippingCarrier-list': 'Listar Transportadoras',
      'transportation-shippingCarrier-update': 'Actualizar Transportadora',
      'transportation-task-create': 'Crear Tarea',
      'transportation-task-get': 'Obtener Tarea',
      'transportation-task-list': 'Listar Tareas',
      'transportation-task-update': 'Actualizar Tarea',
      'transportation-trailer-create': 'Crear Remolque',
      'transportation-trailer-get': 'Obtener Remolque',
      'transportation-trailer-list': 'Listar Remolques',
      'transportation-trailer-update': 'Actualizar Remolque',
      'transportation-transportationType-create': 'Crear Tipo de Transporte',
      'transportation-transportationType-delete': 'Eliminar Tipo de Transporte',
      'transportation-transportationType-get': 'Obtener Tipo de Transporte',
      'transportation-transportationType-list': 'Listar Tipos de Transporte',
      'transportation-transportationType-update':
        'Actualizar Tipo de Transporte',
      'transportation-truck-create': 'Crear Camion',
      'transportation-truck-get': 'Obtener Camion',
      'transportation-truck-list': 'Listar Camiones',
      'transportation-truck-update': 'Actualizar Camion',
    },
    descriptions: {
      'general-userInput': 'Solicita informacion al usuario',
      'general-dateTime': 'Devuelve la fecha y hora actual',
      'crm-account-list':
        'Busca cuentas de CRM basado en un conjunto de filtros',
      'crm-account-get': 'Obtiene una cuenta especifica por su ID',
      'crm-account-create': 'Crea una cuenta de CRM',
      'crm-account-delete': 'Elimina una cuenta de CRM',
      'crm-account-update': 'Actualiza una cuenta de CRM',
      'crm-accountAddress-create': 'Crea una direccion de cuenta',
      'crm-accountAddress-delete': 'Elimina una direccion de cuenta',
      'crm-accountAddress-get':
        'Obtiene una direccion de cuenta especifica por su ID',
      'crm-accountAddress-list':
        'Busca direcciones de cuenta basado en un conjunto de filtros',
      'crm-accountAddress-update': 'Actualiza una direccion de cuenta',
      'crm-contact-list': 'Busca contactos de cuenta en el modulo de CRM',
      'crm-contact-create': 'Crea un contacto',
      'crm-contact-delete': 'Elimina un contacto',
      'crm-contact-get': 'Obtiene un contacto especifico por su ID',
      'crm-contact-update': 'Actualiza un contacto',
      'crm-customerInvitation-accept': 'Acepta una invitacion de cliente',
      'crm-customerInvitation-cancel': 'Cancela una invitacion de cliente',
      'crm-customerInvitation-create': 'Crea una invitacion de cliente',
      'crm-customerInvitation-get':
        'Obtiene una invitacion de cliente por su ID',
      'crm-customerInvitation-getByToken':
        'Obtiene una invitacion de cliente por su token',
      'crm-customerInvitation-list':
        'Busca invitaciones de cliente basado en un conjunto de filtros',
      'sales-salesOrder-list':
        'Busca ordenes de venta basado en un conjunto de filtros',
      'sales-salesOrder-get': 'Obtiene una orden de venta especifica por su ID',
      'sales-salesOrder-create': 'Crea una orden de venta',
      'sales-salesOrder-update': 'Actualiza una orden de venta',
      'sales-booking-create': 'Crea una reserva',
      'sales-booking-get': 'Obtiene una reserva especifica por su ID',
      'sales-booking-list': 'Busca reservas basado en un conjunto de filtros',
      'sales-booking-update': 'Actualiza una reserva',
      'sales-deductionType-create': 'Crea un tipo de deduccion',
      'sales-deductionType-delete': 'Elimina un tipo de deduccion',
      'sales-deductionType-get':
        'Obtiene un tipo de deduccion especifico por su ID',
      'sales-deductionType-list':
        'Busca tipos de deduccion basado en un conjunto de filtros',
      'sales-deductionType-update': 'Actualiza un tipo de deduccion',
      'sales-load-create': 'Crea una carga',
      'sales-load-get': 'Obtiene una carga especifica por su ID',
      'sales-load-list': 'Busca cargas basado en un conjunto de filtros',
      'sales-load-update': 'Actualiza una carga',
      'sales-loadReconciliation-delete': 'Elimina una conciliacion de carga',
      'sales-loadReconciliation-update': 'Actualiza una conciliacion de carga',
      'inventory-item-list':
        'Lista y busca articulos de inventario (materiales) en la Biblioteca de Inventario',
      'inventory-item-get': 'Obtiene un articulo de inventario por su ID',
      'inventory-item-create': 'Crea un articulo de inventario',
      'inventory-item-delete': 'Elimina un articulo de inventario',
      'inventory-item-update': 'Actualiza un articulo de inventario',
      'inventory-category-create': 'Crea una categoria de inventario',
      'inventory-category-delete': 'Elimina una categoria de inventario',
      'inventory-category-get':
        'Obtiene una categoria de inventario especifica por su ID',
      'inventory-category-list':
        'Busca categorias de inventario basado en un conjunto de filtros',
      'inventory-category-update': 'Actualiza una categoria de inventario',
      'inventory-inventoryTag-create': 'Crea una etiqueta de inventario',
      'inventory-inventoryTag-delete': 'Elimina una etiqueta de inventario',
      'inventory-inventoryTag-get':
        'Obtiene una etiqueta de inventario especifica por su ID',
      'inventory-inventoryTag-list':
        'Busca etiquetas de inventario basado en un conjunto de filtros',
      'inventory-inventoryTag-update': 'Actualiza una etiqueta de inventario',
      'inventory-itemGroup-create': 'Crea un grupo de articulos de inventario',
      'inventory-itemGroup-delete':
        'Elimina un grupo de articulos de inventario',
      'inventory-itemGroup-get':
        'Obtiene un grupo de articulos de inventario especifico por su ID',
      'inventory-itemGroup-list':
        'Busca grupos de articulos de inventario basado en un conjunto de filtros',
      'inventory-itemGroup-update':
        'Actualiza un grupo de articulos de inventario',
      'core-customAttribute-create': 'Crea un atributo personalizado',
      'core-customAttribute-delete': 'Elimina un atributo personalizado',
      'core-customAttribute-get':
        'Obtiene un atributo personalizado especifico por su ID',
      'core-customAttribute-list':
        'Busca atributos personalizados basado en un conjunto de filtros',
      'core-customAttribute-update': 'Actualiza un atributo personalizado',
      'core-customAttribute-validate': 'Valida un atributo personalizado',
      'core-facility-create': 'Crea una instalacion',
      'core-facility-get': 'Obtiene una instalacion especifica por su ID',
      'core-facility-list':
        'Busca instalaciones basado en un conjunto de filtros',
      'core-facilityGroup-assignFacility':
        'Asigna una instalacion a un grupo de instalaciones',
      'core-facilityGroup-create': 'Crea un grupo de instalaciones',
      'core-facilityGroup-get':
        'Obtiene un grupo de instalaciones especifico por su ID',
      'core-facilityGroup-list':
        'Busca grupos de instalaciones basado en un conjunto de filtros',
      'core-facilityGroup-removeFacility':
        'Remueve una instalacion de un grupo de instalaciones',
      'core-facilityGroup-update': 'Actualiza un grupo de instalaciones',
      'core-organization-create': 'Crea una organizacion',
      'core-organization-delete': 'Elimina una organizacion',
      'core-organization-get': 'Obtiene una organizacion especifica por su ID',
      'core-organization-list':
        'Busca organizaciones basado en un conjunto de filtros',
      'core-organization-update': 'Actualiza una organizacion',
      'core-scopedSettingValues-getBySetting':
        'Obtiene valores de configuracion por alcance para una configuracion',
      'core-scopedSettingValues-patch':
        'Actualiza valores de configuracion por alcance',
      'core-setting-create': 'Crea una configuracion',
      'core-setting-delete': 'Elimina una configuracion',
      'core-setting-get': 'Obtiene una configuracion especifica por su ID',
      'core-setting-list':
        'Busca configuraciones basado en un conjunto de filtros',
      'core-setting-update': 'Actualiza una configuracion',
      'core-settingsGroup-create': 'Crea un grupo de configuraciones',
      'core-settingsGroup-delete': 'Elimina un grupo de configuraciones',
      'core-settingsGroup-get':
        'Obtiene un grupo de configuraciones especifico por su ID',
      'core-settingsGroup-list':
        'Busca grupos de configuraciones basado en un conjunto de filtros',
      'core-settingsGroup-update': 'Actualiza un grupo de configuraciones',
      'core-user-create': 'Crea un usuario',
      'core-user-get': 'Obtiene un usuario especifico por su ID',
      'core-user-list': 'Busca usuarios basado en un conjunto de filtros',
      'files-file-generateAccessURL':
        'Genera una URL de acceso para un archivo',
      'files-file-get': 'Obtiene un archivo especifico por su ID',
      'files-file-list': 'Busca archivos basado en un conjunto de filtros',
      'files-fileTemplate-get': 'Obtiene una plantilla de archivo',
      'files-fileTemplate-list':
        'Busca plantillas de archivo basado en un conjunto de filtros',
      'files-fileTemplate-set': 'Establece una plantilla de archivo',
      'files-fileTemplate-remove': 'Remueve una plantilla de archivo',
      'finance-bill-create': 'Crea una factura de proveedor',
      'finance-bill-get':
        'Obtiene una factura de proveedor especifica por su ID',
      'finance-bill-list':
        'Busca facturas de proveedor basado en un conjunto de filtros',
      'finance-financialAccount-create': 'Crea una cuenta financiera',
      'finance-financialAccount-list':
        'Busca cuentas financieras basado en un conjunto de filtros',
      'finance-invoice-create': 'Crea una factura',
      'finance-invoice-get': 'Obtiene una factura especifica por su ID',
      'finance-invoice-list': 'Busca facturas basado en un conjunto de filtros',
      'finance-payment-create': 'Crea un pago',
      'finance-payment-list': 'Busca pagos basado en un conjunto de filtros',
      'purchases-purchaseOrder-list':
        'Busca ordenes de compra basado en un conjunto de filtros',
      'purchases-purchaseOrder-get':
        'Obtiene una orden de compra especifica por su ID',
      'purchases-purchaseOrder-create': 'Crea una orden de compra',
      'purchases-purchaseOrder-update': 'Actualiza una orden de compra',
      'transportation-asset-create': 'Crea un activo de transporte',
      'transportation-asset-delete': 'Elimina un activo de transporte',
      'transportation-asset-get':
        'Obtiene un activo de transporte especifico por su ID',
      'transportation-asset-list':
        'Busca activos de transporte basado en un conjunto de filtros',
      'transportation-asset-update': 'Actualiza un activo de transporte',
      'transportation-assetType-create': 'Crea un tipo de activo de transporte',
      'transportation-assetType-delete':
        'Elimina un tipo de activo de transporte',
      'transportation-assetType-get':
        'Obtiene un tipo de activo de transporte especifico por su ID',
      'transportation-assetType-list':
        'Busca tipos de activo de transporte basado en un conjunto de filtros',
      'transportation-assetType-update':
        'Actualiza un tipo de activo de transporte',
      'transportation-containerType-create': 'Crea un tipo de contenedor',
      'transportation-containerType-delete': 'Elimina un tipo de contenedor',
      'transportation-containerType-get':
        'Obtiene un tipo de contenedor especifico por su ID',
      'transportation-containerType-list':
        'Busca tipos de contenedor basado en un conjunto de filtros',
      'transportation-containerType-update': 'Actualiza un tipo de contenedor',
      'transportation-driver-create': 'Crea un conductor',
      'transportation-driver-get': 'Obtiene un conductor especifico por su ID',
      'transportation-driver-list':
        'Busca conductores basado en un conjunto de filtros',
      'transportation-driver-update': 'Actualiza un conductor',
      'transportation-freightForwarder-create': 'Crea un agente de carga',
      'transportation-freightForwarder-delete': 'Elimina un agente de carga',
      'transportation-freightForwarder-get':
        'Obtiene un agente de carga especifico por su ID',
      'transportation-freightForwarder-list':
        'Busca agentes de carga basado en un conjunto de filtros',
      'transportation-freightForwarder-update': 'Actualiza un agente de carga',
      'transportation-freightLine-create': 'Crea una linea de flete',
      'transportation-freightLine-delete': 'Elimina una linea de flete',
      'transportation-freightLine-get':
        'Obtiene una linea de flete especifica por su ID',
      'transportation-freightLine-list':
        'Busca lineas de flete basado en un conjunto de filtros',
      'transportation-freightLine-update': 'Actualiza una linea de flete',
      'transportation-hauler-add': 'Agrega un transportista',
      'transportation-hauler-remove': 'Remueve un transportista',
      'transportation-route-create': 'Crea una ruta',
      'transportation-route-get': 'Obtiene una ruta especifica por su ID',
      'transportation-route-list':
        'Busca rutas basado en un conjunto de filtros',
      'transportation-route-update': 'Actualiza una ruta',
      'transportation-shippingCarrier-create': 'Crea una transportadora',
      'transportation-shippingCarrier-delete': 'Elimina una transportadora',
      'transportation-shippingCarrier-get':
        'Obtiene una transportadora especifica por su ID',
      'transportation-shippingCarrier-list':
        'Busca transportadoras basado en un conjunto de filtros',
      'transportation-shippingCarrier-update': 'Actualiza una transportadora',
      'transportation-task-create': 'Crea una tarea de transporte',
      'transportation-task-get':
        'Obtiene una tarea de transporte especifica por su ID',
      'transportation-task-list':
        'Busca tareas de transporte basado en un conjunto de filtros',
      'transportation-task-update': 'Actualiza una tarea de transporte',
      'transportation-trailer-create': 'Crea un remolque',
      'transportation-trailer-get': 'Obtiene un remolque especifico por su ID',
      'transportation-trailer-list':
        'Busca remolques basado en un conjunto de filtros',
      'transportation-trailer-update': 'Actualiza un remolque',
      'transportation-transportationType-create': 'Crea un tipo de transporte',
      'transportation-transportationType-delete':
        'Elimina un tipo de transporte',
      'transportation-transportationType-get':
        'Obtiene un tipo de transporte especifico por su ID',
      'transportation-transportationType-list':
        'Busca tipos de transporte basado en un conjunto de filtros',
      'transportation-transportationType-update':
        'Actualiza un tipo de transporte',
      'transportation-truck-create': 'Crea un camion',
      'transportation-truck-get': 'Obtiene un camion especifico por su ID',
      'transportation-truck-list':
        'Busca camiones basado en un conjunto de filtros',
      'transportation-truck-update': 'Actualiza un camion',
    },
  },
};
